/**
 * ACORDE — Animación al entrar en pantalla. Cualquier elemento con `data-acorde-anima` recibe la
 * clase `acorde-anima` al cargar (estado inicial: barras en cero) y `acorde-anima--visible` la
 * primera vez que más de un tercio de él entra en pantalla (las barras se llenan con transición).
 * Sin JavaScript, las barras se pintan llenas desde el principio: nada se pierde.
 */
const elementos = document.querySelectorAll('[data-acorde-anima]');
if (elementos.length && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observador = new IntersectionObserver(
    (entradas) => {
      for (const e of entradas) {
        if (e.intersectionRatio >= 0.35) {
          e.target.classList.add('acorde-anima--visible');
          observador.unobserve(e.target);
        }
      }
    },
    { threshold: [0, 0.35, 1] }
  );
  for (const el of elementos) {
    el.classList.add('acorde-anima');
    // Dos cuadros después, para que el estado inicial (cero) se pinte antes de la transición.
    requestAnimationFrame(() => requestAnimationFrame(() => observador.observe(el)));
  }
}
